<mat-toolbar class="mc-toolbar-normal mc-border-radius-normal mc-toolbar-outer-spacing-large" color="caution">
  <mat-icon class="mc-centered-text-icon" fontSet="project-titan" fontIcon="icon-warning-filled"></mat-icon>
  <span class="mc-toolbar-spacer-small"></span>
  External commits have been detected.

  <ng-container *ngIf="!readonly">
    <span class="mc-fill-remaining-flex-space"></span>

    <button mat-flat-button class="mc-toolbar-item-full mc-toolbar-item-full-end mc-border-top-right-radius-normal mc-border-bottom-right-radius-normal mc-workspace-pull-change-bar-pull-button" color="caution" (click)="onPullChangesClicked()">
      {{ type === 'doc' ? 'Pull Changes' : 'Pull All Changes' }}
    </button>
  </ng-container>
</mat-toolbar>